export enum SelfOnboardingRoutes {
  Base = 'self-onboarding',
  CampaignsManagement = 'campaigns-management',
  LandingPages = 'landing-pages',
  Leads = 'leads',
  EmailTemplates = 'email-templates',
}
